import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";

export default function Logo({
  pathname = "",
  className = "",
}: {
  pathname?: string;
  className?: string;
}) {
  const isPostPage = pathname.startsWith(`/blog/`);

  return (
    <div className={clsx({ "mr-auto": isPostPage })}>
      <Link href={"/"}>
        <Image
          src="/images/logo-voccaria.png"
          height={220}
          width={200}
          className={clsx(
            "w-38 -translate-y-0.5 max-sm:w-30 max-sm:translate-y-0 dark:brightness-105",
            className,
          )}
          alt="Voccaria logo"
          priority
        />
      </Link>
    </div>
  );
}
